import {connectedAtom} from "../js/ConnectedStore";
import {parseAllActivities} from "../js-app/util/app-util";
import {Activity} from "../js-app/state";
import {MemoItem} from "../js/app";

const allActivitieis = parseAllActivities();

//Finds an Activity element from a fiven booking/wp-ID
export function getActivitiyData(m:MemoItem):Activity{
	var k = allActivitieis?.find((e)=>{
		if(m.wpID && e.id == m.wpID) return true;
		if(m.bookingID){
			if(e.variants[m.bookingID]) return true;
		}
		return false;
	});
	if(!k) console.log(`WARNING:`,m,` not found.`);
	return k;
}